// extracted by mini-css-extract-plugin
module.exports = {"root":"NavbarCardSlider_root__cXmp5","header":"NavbarCardSlider_header__LYHi3","cards":"NavbarCardSlider_cards__NcpoW","cardsWrapper":"NavbarCardSlider_cardsWrapper__CO0kM"};